export default __webpack_public_path__ + "static/media/NamesAlbumCover1980x1980.db80b3db.jpg";